import { compose, withState, lifecycle } from 'recompose'

import supportsObjectFit from '../utils/supportsObjectFit'

const withObjectFitSupportDetection = compose(
  withState('objectFitSupported', 'setObjectFitSupported', true),
  lifecycle({
    componentDidMount() {
      const { setObjectFitSupported } = this.props
      setObjectFitSupported(supportsObjectFit())
    }
  })
)

export default withObjectFitSupportDetection
